import React from "react";

import DashboardV3 from "./DashboardV3";

export default function Dashboard(props) {
  return <DashboardV3 />;
}
